import { memo, ReactNode } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { CustomReportsContext, CustomReportsFunctions } from '.';

interface Props {
  children: ReactNode;
}

function CustomReportsProvider({ children }: Props) {
  const customReports = CustomReportsFunctions();
  return <CustomReportsContext.Provider value={{ ...customReports }}>{children}</CustomReportsContext.Provider>;
}

const CustomReportsProviderMemo = memo(CustomReportsProvider, areEqual);
export { CustomReportsProviderMemo as CustomReportsProvider };
